import * as React from "react";
const SvgRefresh = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.16732 16.5923C12.9173 17.0833 16.6673 13.6819 16.6673 10C16.6673 7.8951 15.6918 6.01804 14.1682 4.79626M9.16732 16.5923L10.834 18.3333M9.16732 16.5923L10.834 15M10.834 3.3295C7.08398 2.91663 3.33398 6.31811 3.33398 10C3.33398 12.1046 4.30916 13.9813 5.8323 15.2031M10.834 3.3295L9.16732 1.66663M10.834 3.3295L9.16732 4.99996",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgRefresh;
